// extracted by mini-css-extract-plugin
export default {"Box":"BlueBox_Box__KFE3G","Image":"BlueBox_Image__TImFC"};